// src/components/ui/ColumnLabel.jsx
//
// Patrón ".blk-title" del mockup de Inicio: etiqueta uppercase pequeña +
// línea horizontal que ocupa el resto del ancho. Se usa como encabezado
// de columna/sección (ej. "MIS DESPACHOS", "REPOSITORIO DE FINALIZADOS"),
// para que ambas columnas arranquen a la misma altura visual.

import React from 'react';
import { Box, Typography } from '@mui/material';
import { tokens } from '../../theme/tokens';

const ColumnLabel = ({ children }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
    <Typography
      sx={{
        fontSize: 12.5,
        fontWeight: 700,
        letterSpacing: '.5px',
        textTransform: 'uppercase',
        color: tokens.colors.muted,
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </Typography>
    <Box sx={{ flex: 1, height: '1px', backgroundColor: tokens.colors.line }} />
  </Box>
);

export default ColumnLabel;